import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { PrimaryButton } from '../ClickableComponents/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const DropdownApplyButton = ({
  onClick,
  hasChanges
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(ApplyButtonContainer, {
    children: /*#__PURE__*/_jsx(PrimaryButton, {
      type: "text",
      onClick: onClick,
      text: hasChanges ? t('global.save') : t('global.close'),
      expand: true
    })
  });
};
const ApplyButtonContainer = styled.div.withConfig({
  displayName: "DropdownApplyButton__ApplyButtonContainer",
  componentId: "sc-1jqhlws-0"
})(["padding:16px 16px 8px;display:flex;align-items:center;"]);